import { Box, Popover, SxProps, useTheme } from "@mui/material";
import { useState } from "react";

interface ITooltipWrapper {
  tooltipComponent: JSX.Element | null;
  children: React.ReactNode;
  sx?: SxProps;
}

const TooltipWrapperV2 = ({ tooltipComponent, children, sx }: ITooltipWrapper) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose} sx={sx}>
        {children}
      </Box>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
          "& .MuiPopover-paper": {
            borderRadius: theme.spacing(1),
            backgroundColor: theme.palette.dsBase.v100,
          },
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableScrollLock
      >
        {tooltipComponent}
      </Popover>
    </>
  );
};

export default TooltipWrapperV2;
